"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.patchInitiativeById = void 0;
const patchInitiatives_1 = require("./patchInitiatives.js");
const patchInitiativeById = (request) => (0, patchInitiatives_1.patchInitiatives)({
    initiativeIds: [request.initiativeId],
    patchInitiativeDescription: request.patchInitiativeDescription
});
exports.patchInitiativeById = patchInitiativeById;
//# sourceMappingURL=patchInitiativeById.js.map